import { render } from "./GroupsCard.vue?vue&type=template&id=a0316f1c&scoped=true&lang=pug"
import script from "./GroupsCard.vue?vue&type=script&lang=js"
export * from "./GroupsCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/adolforeyna/Projects/EMI/website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0316f1c"]])

export default __exports__